import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { callBuddyApi } from '../lib/apiCallBuddy'
import type {
  CallBuddyOverviewResponse,
  CallBuddyReportParams,
  CallDetail,
  FollowUpReportParams,
  FollowUpReportResponse,
} from '../types/callbuddy'

export const useCallBuddyOverview = (params?: CallBuddyReportParams, enabled = true) => {
  return useQuery<CallBuddyOverviewResponse>({
    queryKey: ['callbuddy-reports', 'overview', params],
    queryFn: () => callBuddyApi.overview(params),
    enabled,
    staleTime: 1000 * 60 * 5,
  })
}

export const useCallBuddyFollowUps = (params?: FollowUpReportParams, enabled = true) => {
  return useQuery<FollowUpReportResponse>({
    queryKey: ['callbuddy-reports', 'follow-ups', params],
    queryFn: () => callBuddyApi.followUps(params),
    enabled,
    staleTime: 1000 * 60 * 2,
  })
}

export const useCallDetail = (id: string | null, enabled = true) => {
  return useQuery<CallDetail>({
    queryKey: ['callbuddy-reports', 'call-detail', id],
    queryFn: () => callBuddyApi.callDetail(id!),
    enabled: enabled && !!id,
    staleTime: 1000 * 60 * 2,
  })
}

export const useToggleFollowedUp = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, followed_up }: { id: string; followed_up?: boolean }) =>
      callBuddyApi.toggleFollowedUp(id, followed_up),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['callbuddy-reports', 'follow-ups'] })
      queryClient.invalidateQueries({ queryKey: ['callbuddy-reports', 'call-detail'] })
    },
  })
}
